import { UserRole } from './rolesConfig';

export const checkRoleAccessibility = (
  allowedRolesOrGroup: UserRole[] | string,
  userRole: UserRole,
  Groups: Record<string, UserRole[]>,
  UserGroups: Record<string, string>,
): boolean => {
  let allowedRoles: UserRole[] = [];

  if (Array.isArray(allowedRolesOrGroup)) {
    allowedRoles = allowedRolesOrGroup;
  } else {
    const groupName = UserGroups[allowedRolesOrGroup as keyof typeof UserGroups] ?? allowedRolesOrGroup;
    allowedRoles = Groups[groupName] ?? [];
  }
  return allowedRoles.includes(userRole);
};
